import { ActivatedRoute, Router } from '@angular/router';
import { DataAnalyticsService } from './../../../services/data-analytics.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, ElementRef, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import * as c3 from 'c3';
import { Subscription } from 'rxjs';
import { Usagereport } from 'src/app/shared/handlers/usagereport';

const COLORS = [
  '#515CB4', '#D26999', '#72A8D5', '#82C7C2', '#7FE593',
  '#8F82C7', '#BF82C7', '#D27969', '#FDBF6F', '#FD8A6F',
  '#00A19D', '#FFB344', '#E05D5D', '#2D2424', '#52006A'
];
@Component({
  selector: 'app-view-more',
  templateUrl: './view-more.component.html',
  styleUrls: ['./view-more.component.scss']
})
export class ViewMoreComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('graphDiv') graphDiv: ElementRef;
  chart: any;

  factorySummary: any;
  selectedCostContributionItem: string;
  costContributionItems: Array<any> = [];
  filteredCostContributionItems: Array<any> = [];
  graphData: Array<any> = [];
  graphColorObj = {};
  searchKeyword = '';
  graphHoverTitleT = '';
  graphHoverCostT = '';
  graphHoverPercentageT = '';
  isLoading = false;
  searchPlaceHolder: string;
  level: string;
  lineId: string;
  lineName: string;
  pageNumber = 1;
  pageSize = 15;
  subscrib: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private daService: DataAnalyticsService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogRef: MatDialog,
    private usageReport: Usagereport
  ) { }

  ngOnInit() {
    this.isLoading = true;
    // this.costContributionItems = this.filteredCostContributionItems = this.data.costContributionItems;
    // this.graphData = this.data.graphData;
    // this.graphColorObj = this.data.graphColorObj;
    this.factorySummary = this.data.factorySummary;
    this.selectedCostContributionItem = this.data.selectedCostContribution;
    this.isLoading = false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.subscrib = this.route.queryParams.subscribe(params => {
        if (params.level && params.factory) {
          this.level = params.level;
          // if (this.level === 'factory') {
          //   this.selectedCostContribution = 'Line';
          // } else if (this.level === 'line') {
          //   this.selectedCostContribution = 'Sku';
          // }
          this.lineId = (params.LineId) ? params.LineId : null;
          this.lineName = params.LineName;
          this.drawGraph(this.lineId);
        }
      });
      this.generateDonutChart();
    }, 0);
  }

  drawGraph(lineId = null) {
    const params: any = {
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      FactoryId: this.factorySummary.factoryId,
      Level: this.level,
      SplitBy: this.selectedCostContributionItem,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize
    };
    if (this.level === 'line') {
      params.LineId = lineId;
    }
    this.isLoading = true;
    this.daService.getCostContributionList(params).subscribe((res => {
      if (res) {
        const cc = res.map((item, index) => {
          return {
            id: (this.selectedCostContributionItem === 'Line') ? item.id : (item.name ? item.name : 'Null'),
            name: (this.selectedCostContributionItem === 'Line' && item.name && item.name !== 'Not Available') ?
              (item.name) ? item.name : 'Null' : item.id,
            // color: (index <= COLORS.length) ? COLORS[index] : this.getRandomColor(),
            percentage: Number(Math.round((item.waste / Math.abs(item.totalWaste)) * 100)),
            cost: item.waste
          };
        });

        if (this.selectedCostContributionItem === 'Line') {
          cc.forEach((item, index) => {
            item.color = (index <= COLORS.length) ? COLORS[index] : this.getRandomColor();
          });
        } else {
          if (this.costContributionItems.length > 15) {
            cc.forEach((item, index) => {
              item.color = this.getRandomColor();
            });
          } else {
            cc.forEach((item, index) => {
              item.color = COLORS[index];
            });
          }
        }

        this.costContributionItems.push(...cc);

        this.costContributionItems.forEach(element => {
          if (isNaN(element.percentage)) {
            element.percentage = 0;
          }
        });
        this.costContributionItems.sort((a, b) => {
          return a.percentage === b.percentage ? 0 : a.percentage < b.percentage ? 1 : -1;
        });

        let duplicateCount = 1;
        this.graphColorObj = this.costContributionItems.reduce((acc, item) => {
          if (acc[item.name]) {
            acc[item.name + duplicateCount] = item.color;
            duplicateCount++;
          }
          acc[item.name] = item.color;
          return acc;
        }, {});
        this.graphData = this.costContributionItems.reduce((acc, item) => {
          acc.push([item.name, item.percentage]);
          return acc;
        }, []);
        this.filteredCostContributionItems = [...this.costContributionItems];
        this.isLoading = false;
        this.generateDonutChart();
      } else {
        this.isLoading = false;
        this.pageNumber--;
      }
    }));
  }

  setSearchPlaceHolder(type: string) {
    switch (type) {
      case 'Line':
        this.searchPlaceHolder = 'Search for a Line Name';
        break;
      case 'Sku':
        this.searchPlaceHolder = 'Search for a SKU id or SKU name';
        break;
      case 'Bom':
        this.searchPlaceHolder = 'Search for a BoM id or BoM name';
        break;
    }
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  generateDonutChart() {
    this.setSearchPlaceHolder(this.selectedCostContributionItem);
    this.chart = c3.generate({
      bindto: this.graphDiv.nativeElement,
      size: {
        height: 300,
        width: 300
      },
      data: {
        columns: this.graphData || [],
        type: 'donut',
        colors: this.graphColorObj || {}
      },
      donut: {
        title: '',
        width: 25,
        label: {
          show: false
        },
        expand: true,
      },
      legend: {
        hide: true
      },
      tooltip: {
        format: {
          value(value, ratio, id) {
            return `${value}%`;
          }
        }
      }
    });
  }

  onChange(event) {
    this.selectedCostContributionItem = event.value;
    this.pageNumber = 1;
    this.searchKeyword = '';
    this.costContributionItems = [];
    this.filteredCostContributionItems = [];
    this.drawGraph(this.lineId);
  }

  search(keyword: string): void {

    if (keyword && keyword !== '') {
      this.searchKeyword = keyword;
      const clonedCCList = [...this.costContributionItems];
      this.filteredCostContributionItems = clonedCCList.filter(f => {
        if (this.selectedCostContributionItem !== 'Line') {
          return f.name.toLowerCase().includes(keyword.toLowerCase()) ||
            f.id.toLowerCase().includes(keyword.toLowerCase());
        } else {
          return f.name.toLowerCase().includes(keyword.toLowerCase());
        }
      });
    } else {
      this.filteredCostContributionItems = this.costContributionItems;
    }
  }

  setGraphTitle(item = null) {
    if (item) {
      this.graphHoverTitleT = item.name;
      this.graphHoverCostT = item.cost;
      this.graphHoverPercentageT = `${item.percentage}%`;
    } else {
      this.graphHoverTitleT = '';
      this.graphHoverCostT = '';
      this.graphHoverPercentageT = '';
    }
  }

  onClickCostContributionItem(item: any) {

    let level = '';
    let cluster = null;
    let factory = null;
    let line = null;
    const sku = null;
    if (this.selectedCostContributionItem === 'Line') {
      level = 'Factory';
      cluster = this.factorySummary.clusterId;
      factory = this.factorySummary.factoryName;
    }
    if (this.selectedCostContributionItem === 'Sku') {
      level = 'Line';
      cluster = this.factorySummary.clusterId;
      factory = this.factorySummary.factoryName;
      line = this.lineId;
    }

    this.usageReport.report('Insight Dashboard - ' + level, this.data.startTime, cluster, factory, line, sku);

    this.graphHoverTitleT = '';
    this.graphHoverCostT = '';
    this.graphHoverPercentageT = '';
    if (this.subscrib) {
      this.subscrib.unsubscribe();
    }
    if (this.selectedCostContributionItem === 'Line') {
      const queryParamsDataItem: any = {
        cluster: this.factorySummary.clusterId,
        factory: this.factorySummary.factoryId,
        FromDate: this.factorySummary.fromDate,
        ToDate: this.factorySummary.toDate,
      };
      if (this.level === 'factory') {
        queryParamsDataItem.level = 'line';
        queryParamsDataItem.LineId = item.id;
        queryParamsDataItem.LineName = item.name && item.name.toLowerCase() === 'not available' ? item.id : item.name;

      }
      this.router.navigate([],
        {
          relativeTo: this.route,
          queryParams: queryParamsDataItem,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
      this.dialogRef.closeAll();
    } else if (this.level !== 'factory' && this.selectedCostContributionItem === 'Sku') { // actual is Sku
      this.dialogRef.closeAll();
      const url = '/sku-insights?cluster=' + this.factorySummary.clusterId +
        '&factory=' + this.factorySummary.factoryId + '&skuId=' + item.id + '&skuName=' + item.name +
        '&lineId=' + this.lineId + '&lineName=' + this.lineName + '&FromDate=' + this.factorySummary.fromDate +
        '&ToDate=' + this.factorySummary.toDate + '&level=sku';

      this.router.navigateByUrl(url);
    }
  }

  onScroll(event) {
    if (this.selectedCostContributionItem !== 'Line') {
      if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
        this.pageNumber++;
        this.drawGraph(this.lineId);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscrib) {
      this.subscrib.unsubscribe();
    }
  }

}
